import React, { useCallback, useMemo } from "react";
import styled, { css } from "styled-components";
import Link from "next/link";

import StyledButton from "../styled/StyledButton";

const StyledErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-left: 20px;
  padding-right: 20px;

  .message-content {
    display: flex;
    justify-content: center;

    font-family: "MerriweatherLight";
    font-size: 18px;
    line-height: 28px;
    color: #c61f0c;
    text-align: center;

    ${({ showContactUsLink }) =>
      showContactUsLink &&
      css`
        color: #1b3858;
      `};
  }

  .action-block {
    margin-top: 32px;
  }
`;

function ErrorMessage({
  showContactUsLink,
  showOK = { text: null, onClick: () => {} },
  message = "Something went wrong",
  error,
}) {
  const messageContent = useMemo(() => {
    if (error && error?.message) {
      if (error.message?.errors) {
        return error.message.errors[0];
      }

      if (!error.message?.errors) {
        return error.message;
      }
    }

    return message;
  }, [message, error]);

  const handleOK = useCallback(() => {
    showOK?.onClick && showOK.onClick();
  }, [showOK]);

  return (
    <StyledErrorMessage showContactUsLink={showContactUsLink}>
      <div className="message-content">{messageContent}</div>
      {showContactUsLink && (
        <div className="action-block">
          <Link href="/contactus" passHref>
            <StyledButton>Contact Us</StyledButton>
          </Link>
        </div>
      )}
      {showOK?.text && (
        <div className="action-block">
          <StyledButton onClick={handleOK}>{showOK?.text}</StyledButton>
        </div>
      )}
    </StyledErrorMessage>
  );
}

export default ErrorMessage;
